import React, { Component } from "react";
import AntdPopover, {PopoverProps} from 'antd/lib/popover';
import 'antd/lib/popover/style';

export default class Popover extends Component<PopoverProps> {
    render() {
        return (
          <AntdPopover {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/popover/index.tsx